import * as React from "react";
import { SVGProps } from "react";

const Frax = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 570 570"
    {...props}
  >
    <g transform="translate(295.658 -75.719)">
      <circle
        cx={-10.5}
        cy={360.9}
        r={284.6}
        fillRule="evenodd"
        stroke="#000"
        strokeMiterlimit={11.339}
        strokeWidth={1.237}
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        d="M-167.5 202.6c-12 12.6-21.9 23.2-22 23.4-.1.3 10.7 10.9 24 23.5 13.3 12.7 24.9 23.8 25.7 24.5l1.5 1.4-2.7 4.5c-23.7 39.2-28.6 86.4-13.7 129.8 2.8 8.2 7.6 18.7 11.7 25.6 2 3.4 2.9 5.6 2.7 6-.2.4-12.3 13.2-26.9 28.5-14.6 15.2-26.5 27.9-26.7 28.1-.1.3 40.8 39.8 44.7 43l1.5 1.3 23.1-24.1c12.7-13.3 24.6-25.8 26.4-27.7l3.4-3.4 3.2 2c16.3 10.4 35.4 17.6 56.5 21.4 10.6 1.9 30.8 2.4 42.1 1 21.8-2.5 43.4-9.8 61.1-20.5l4.6-2.8 4.9 4.8c10.7 10.4 50.7 48.4 51.1 48.6.4.2 44.3-45.7 44.2-46.3-.1-.3-30.2-29.2-48.6-46.5l-6.1-5.8 2.8-4.6c23.5-39.1 28.4-86.5 13.2-130.2-2.2-6.4-8.9-20.8-12.8-27.4l-1.9-3.3 25.7-26.9c14.1-14.7 25.6-27 25.5-27.3-.4-1-45.4-43.5-46-43.5-.4 0-11.7 11.5-25.2 25.7-13.5 14.1-24.7 25.7-25 25.8-.2.1-1.5-.5-2.7-1.4-3.4-2.3-12-7-16.8-9.2-14.6-6.7-28.2-10.8-44-13.1-8.2-1.2-32.8-1.4-40.4-.3-18.2 2.6-33.1 7.1-48.3 14.7-4.4 2.1-9.5 4.9-11.5 6.1l-3.6 2.2-4.1-4c-2.2-2.2-12.2-11.6-22.1-21.1-9.9-9.4-20-19-22.4-21.4l-4.4-4.3-21.7 23.2zM.4 267.8c15.9 1.9 30.1 7.3 43.2 16.5C50.3 289 60.3 299 65 305.7c26.7 37.8 21.6 89.2-12 120.7-28.7 26.8-70.2 32.8-105.1 15-25.2-12.9-43-36.5-48.7-64.8-1.8-9-1.8-25.8 0-34.7 1.7-8.8 4-15.1 8.3-23.9C-75.3 283.4-38 263.2.4 267.8z"
      />
    </g>
  </svg>
);

export default Frax;
